// extracted by mini-css-extract-plugin
export default {"tab__container":"styles_tab__container__Lvvs7","tab__item":"styles_tab__item__XMUp4","tab__text":"styles_tab__text__Kj66G","tab__item--actived":"styles_tab__item--actived__E1OXi"};